import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

/**
 * Desktop only. OAuth sign-in and payment round trips leave the app for the
 * system browser, and the provider sends the user back through a photentra://
 * link. Electron's main process turns that link into an ordinary app route and
 * pushes it here; from the app's point of view it is just a navigation.
 *
 * Renders nothing, and does nothing at all in a browser.
 */
export default function DeepLinkListener() {
	const navigate = useNavigate();

	useEffect(() => {
		if (!window.photentra?.onDeepLink) return undefined;

		// Subscribing also tells the main process the renderer is ready, which
		// releases any link that arrived during a cold start — a click in the
		// browser can launch the app and beat React to it.
		return window.photentra.onDeepLink((route) => {
			// replace, not push: a token-bearing URL should not sit in history,
			// matching how AuthCallback clears it on the web.
			navigate(route, { replace: true });
		});
	}, [navigate]);

	return null;
}
